import React, { useEffect } from 'react';
import cl from './ShippingPolicy.module.css';
import { Link, animateScroll as scroll } from "react-scroll";



const ShippingPolicy = (props) => {

    useEffect(() => {
      scroll.scrollToTop();
    }, []);

    return (
      <section className={cl.app_policy}>
        <h1>Politica di Spedizione</h1>
        <p>Ultimo aggiornamento: 07 febbraio 2024</p>
        <p>
          Il nostro obiettivo è offrirti le migliori opzioni di spedizione,
          ovunque tu viva. Consegniamo a centinaia di clienti in tutto il mondo
          ogni giorno e ci sforziamo di fornirti servizi del più alto livello.
        </p>
        <p>
          Sappiamo che una volta che hai acquistato qualcosa sei desideroso di
          ricevere il tuo ordine il prima possibile. Si prega di vedere di
          seguito per maggiori dettagli sulla politica di spedizione.
        </p>
        <p>Domanda: Puoi garantire tempi di spedizione?</p>
        <p>
          Risposta: Purtroppo no, poiché questi dipendono dal servizio postale.
          Spediamo gli ordini non appena siamo in grado di farlo dopo aver
          ricevuto il tuo pagamento. Non elaboriamo ordini durante il fine
          settimana o durante le festività.
        </p>
        <p>Domanda: Posso tracciare il mio ordine?</p>
        <p>
          Risposta: Sì! Il nostro servizio è completamente tracciabile sui siti
          web.
        </p>
        <p>Domanda: Dove spedite?</p>
        <p>Risposta: Spediamo in tutto il mondo.</p>
        <p>
          Domanda: Posso richiedere un rimborso se il mio ordine non arriva in
          tempo per una certa data?
        </p>
        <p>
          Risposta: No, ci dispiace ma non possiamo rimborsare gli ordini che
          sono già stati spediti. Puoi tuttavia restituire l'ordine se desideri
          un rimborso.
        </p>
        <p>
          A causa dell'influenza del COVID-19 e delle restrizioni politiche di
          vari paesi, ci sarà un grande ritardo in tutte le spedizioni express,
          e la logistica non può garantire completamente il limite di tempo.
        </p>
        <p>Tempo di consegna: 2-7 giorni, tempo di spedizione: 7-15 giorni</p>
      </section>
    );
}

export default ShippingPolicy;
